exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".benutzer-reg-view .captcha-error{color:#ff2b59}.benutzer-reg-view form:not(.ng-submitted) .captcha-error{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/benutzerverwaltung/component/benutzerEditAnlaufstelleView/benutzerEditAnlaufstelleView.scss
// module id = l6pO
// module chunks = 0